export var Frequency;
(function (Frequency) {
    Frequency["Daily"] = "DAILY";
    Frequency["WeeklyOnDay"] = "WEEKLY_ON_DAY";
    Frequency["MonthlyOnFirstWeekday"] = "FIRST";
    Frequency["MonthlyOnSecondWeekday"] = "SECOND";
    Frequency["MonthlyOnThirdWeekday"] = "THIRD";
    Frequency["MonthlyOnFourthWeekday"] = "FOURTH";
    Frequency["MonthlyOnLastWeekday"] = "LAST";
    Frequency["Weekday"] = "WEEKDAY";
    Frequency["Custom"] = "CUSTOM";
})(Frequency || (Frequency = {}));
export var RepeatStrategy;
(function (RepeatStrategy) {
    RepeatStrategy["Daily"] = "DAILY";
    RepeatStrategy["Weekly"] = "WEEKLY";
    RepeatStrategy["Monthly"] = "MONTHLY";
    RepeatStrategy["NoRepetition"] = "NO_REPETITION";
})(RepeatStrategy || (RepeatStrategy = {}));
export var RepeatMonthlyStrategy;
(function (RepeatMonthlyStrategy) {
    RepeatMonthlyStrategy["OnDay"] = "ON_DAY";
    RepeatMonthlyStrategy["OnFirstWeekday"] = "FIRST";
    RepeatMonthlyStrategy["OnSecondWeekday"] = "SECOND";
    RepeatMonthlyStrategy["OnThirdWeekday"] = "THIRD";
    RepeatMonthlyStrategy["OnFourthWeekday"] = "FOURTH";
    RepeatMonthlyStrategy["OnLastWeekday"] = "LAST";
})(RepeatMonthlyStrategy || (RepeatMonthlyStrategy = {}));
